/* Baja Llama - quick add sizes on hover.  Added 2026-10-12.

   The theme's product cards show an Add to Cart button on hover that opens a
   popup where the shopper picks a size. The editorial pages (Button Ups, BOGO)
   skip the popup: hovering the button swaps it for a row of sizes, one click
   adds. This brings that to every standard product grid.

   HOW
   snippets/quick-add-product.liquid prints the product's sizes as JSON in a
   <script data-bl-sizes> inside the quick-add holder (single-option products
   only; anything with a second option like Fit keeps the popup). On a device
   with a real pointer, hovering the holder swaps the button for the size row.
   Clicking a size POSTs to /cart/add.js and fires the theme's own events so
   the cart drawer opens and the count updates exactly as it does for the popup.

   The popup is untouched and is still what mobile, keyboard and screen readers
   get. The size guard (bl-size-guard.js) is unaffected: nothing here is
   pre-selected, every add is a deliberate click on a named size.

   TO REVERT: delete the two lines for this file in layout/theme.liquid.
*/
(function () {
  'use strict';

  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var DONE_MS = 1400;

  function build(holder) {
    if (holder.getAttribute('data-bl-sizes-ready') === '1') return;
    var json = holder.querySelector('script[data-bl-sizes]');
    var btn = holder.querySelector('[data-quick-add-btn]');
    if (!json || !btn) return;

    var sizes;
    try { sizes = JSON.parse(json.textContent); } catch (e) { return; }
    if (!sizes || sizes.length < 2) return;

    holder.setAttribute('data-bl-sizes-ready', '1');

    var row = document.createElement('div');
    row.className = 'bl-qs';
    row.setAttribute('role', 'group');
    row.setAttribute('aria-label', 'Choose a size');

    var label = document.createElement('span');
    label.className = 'bl-qs__label';
    label.textContent = 'Select size';
    row.appendChild(label);

    var list = document.createElement('div');
    list.className = 'bl-qs__list';
    sizes.forEach(function (s) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bl-qs__size';
      b.textContent = s.t;
      b.setAttribute('data-bl-add', s.id);
      if (!s.a) {
        b.disabled = true;
        b.setAttribute('aria-label', s.t + ' sold out');
      }
      list.appendChild(b);
    });
    row.appendChild(list);

    var done = document.createElement('div');
    done.className = 'bl-qs__done';
    done.textContent = 'Added to cart';
    row.appendChild(done);

    holder.appendChild(row);
    holder.classList.add('bl-qs-holder');
  }

  function refreshCart() {
    document.dispatchEvent(new CustomEvent('theme:product:added', { bubbles: true, detail: {} }));
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
  }

  function add(holder, sizeBtn) {
    if (holder.getAttribute('data-bl-busy') === '1') return;
    holder.setAttribute('data-bl-busy', '1');
    sizeBtn.classList.add('is-on');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(sizeBtn.getAttribute('data-bl-add')), quantity: 1 }] })
    })
    .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
    .then(function () {
      holder.classList.add('bl-qs-holder--done');
      refreshCart();
      window.setTimeout(function () {
        holder.classList.remove('bl-qs-holder--done');
        holder.classList.remove('bl-qs-holder--open');
        sizeBtn.classList.remove('is-on');
        holder.removeAttribute('data-bl-busy');
      }, DONE_MS);
    })
    .catch(function () {
      // Fall back to the theme's own popup, which has full error handling.
      sizeBtn.classList.remove('is-on');
      holder.removeAttribute('data-bl-busy');
      holder.classList.remove('bl-qs-holder--open');
      var btn = holder.querySelector('[data-quick-add-btn]');
      if (btn) btn.click();
    });
  }

  document.addEventListener('mouseover', function (e) {
    var holder = e.target.closest && e.target.closest('.product-item [data-quick-add-holder]');
    if (!holder) return;
    build(holder);
    if (holder.getAttribute('data-bl-sizes-ready') === '1') holder.classList.add('bl-qs-holder--open');
  });

  document.addEventListener('mouseout', function (e) {
    var holder = e.target.closest && e.target.closest('.product-item [data-quick-add-holder]');
    if (!holder) return;
    var to = e.relatedTarget;
    if (to && holder.contains(to)) return;
    if (holder.classList.contains('bl-qs-holder--done')) return;
    holder.classList.remove('bl-qs-holder--open');
  });

  document.addEventListener('click', function (e) {
    var size = e.target.closest && e.target.closest('.bl-qs__size');
    if (!size || size.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    add(size.closest('[data-quick-add-holder]'), size);
  }, true);
})();
